import { render, staticRenderFns } from "./HonorLive.vue?vue&type=template&id=4b63a02a"
import script from "./HonorLive.vue?vue&type=script&lang=js"
export * from "./HonorLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports